import { useContext } from 'react';

import { useCompassTheme } from '@circleci/compass';

import { AppContext } from '~/contexts/AppContext';

export const useMediaQuery = (minWidth: number) => {
  const { innerWidth } = useContext(AppContext);
  return innerWidth < minWidth;
};

export const useMobile = () => {
  const theme = useCompassTheme();
  return useMediaQuery(parseInt(theme.mediaQueries.small.replace('px', '')));
};

export const useTablet = () => {
  const theme = useCompassTheme();
  return useMediaQuery(parseInt(theme.mediaQueries.medium.replace('px', '')));
};

export const useDesktop = () => {
  const theme = useCompassTheme();
  return !useMediaQuery(parseInt(theme.mediaQueries.large.replace('px', '')));
};
